
import { BaseTableObject } from '../models/BaseTableObject';
import { MessageInfo } from '../models/MessageInfo';


export class UtilService {

     public static cloneObject<T>(sourceObject: T):T{
        return structuredClone(sourceObject);
    }

    public static setTableBackground<S extends BaseTableObject>(sourceData: S[]) : void {
        for(let i=0; i< sourceData.length; i++){
            if(i%2 === 0){
                sourceData[i].background = '{"backgroundColor": "#F5EACE"}';
            }
            else{
                sourceData[i].background = '{"backgroundColor": "white"}';
            }
        }
    }

    public static getErrorMessageInfo(errors: string): MessageInfo{
        return {header: 'Error',
                messageType: 'danger',
                primaryText: 'OK',
                message: errors,
                cancelText:''}
    }

    public static getSucessMessageInfo(message: string): MessageInfo{
        return {header: 'Confirmation',
                messageType: 'success',
                primaryText: 'OK',
                message: message,
                cancelText:''}
    }
}